import { ContentBlocksModuleLayout } from "entities/modules/types";
import {
  PageModuleDataWithPageId,
  PageModuleStatus,
} from "entities/pages/types";
import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import ModuleTileHeader from "shared/components/ModuleTileHeader";
import { ContentWrapper } from "../../styled";
import OneBigCardSkeleton from "./components/OneBigCard/components/Skeleton";
import TextCardsSkeleton from "./components/TextCards/components/Skeleton";
import ThreeCardsSkeleton from "./components/ThreeCards/components/Skeleton";

interface ContentBlocksProps {
  isLoading: boolean;
  data: PageModuleDataWithPageId;
  onEditComponent: (data: PageModuleDataWithPageId) => void;
  onDeleteComponent: (data: PageModuleDataWithPageId) => void;
  onUpdateStatus: (params: {
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
}

const ContentBlocks: FC<ContentBlocksProps> = ({
  isLoading,
  data,
  onEditComponent,
  onDeleteComponent,
  onUpdateStatus,
}) => {
  const getSkeletonComponent = () => {
    switch (data.layout) {
      case ContentBlocksModuleLayout.OneCardBlock:
        return <OneBigCardSkeleton />;
      case ContentBlocksModuleLayout.ThreeCardBlock:
        return <ThreeCardsSkeleton />;
      case ContentBlocksModuleLayout.TextBlock:
        return <TextCardsSkeleton />;
      default:
        return null;
    }
  };
  return (
    <ContentWrapper>
      {isLoading && (
        <SpaceBetweenCenter>{getSkeletonComponent()}</SpaceBetweenCenter>
      )}
      {!isLoading && (
        <ModuleTileHeader
          module={data}
          onEditComponent={onEditComponent}
          onDeleteComponent={onDeleteComponent}
          onUpdateStatus={onUpdateStatus}
        />
      )}
    </ContentWrapper>
  );
};

export default ContentBlocks;
